import { defineComponent, h, useAttrs } from 'vue'
import { VTabs } from 'vuetify/components'

function normalizeAttrs(attrs) {
  const normalized = { ...attrs }

  if (attrs.backgroundColor != null && normalized.bgColor == null) {
    normalized.bgColor = attrs.backgroundColor
  }

  if (attrs['background-color'] != null && normalized.bgColor == null) {
    normalized.bgColor = attrs['background-color']
  }

  delete normalized.backgroundColor
  delete normalized['background-color']

  return normalized
}

export default defineComponent({
  name: 'VTabsCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  setup(_, { slots }) {
    const attrs = useAttrs()

    return () => h(VTabs, normalizeAttrs(attrs), slots)
  }
})
